import { SpecialIcon, SpecialIcons } from '@ui-lib/components';

const SPECIAL_ICONS: readonly string[] = SpecialIcons;

function isSpecialIcon(key: string): key is SpecialIcon {
  return SPECIAL_ICONS.includes(key);
}

export function toIconKey(name: string | null | undefined): SpecialIcon | null {
  const key = String(name ?? '')
    .trim()
    .toUpperCase();
  return isSpecialIcon(key) ? key : null;
}

export function createCoinPlaceholderSvg(
  coin: string | null | undefined,
  width = 32,
  height = 32,
): string {
  const label = String(coin ?? '')
    .toUpperCase()
    .slice(0, 3);
  const centerX = width / 2;
  const centerY = height * 0.625;
  const svg = encodeURIComponent(`
      <svg xmlns='http://www.w3.org/2000/svg' width='${width}' height='${height}'>
        <rect width='${width}' height='${height}' fill='white'/>
        <text x='${centerX}' y='${centerY}' text-anchor='middle' font-size='10' font-family='Gotham Pro, Inter, Arial, sans-serif' fill='black'>${label}</text>
      </svg>
    `);
  return `data:image/svg+xml;charset=UTF-8,${svg}`;
}

export function parseCoins(input: string | null | undefined): string[] {
  return String(input ?? '')
    .split(',')
    .map((coin) => coin.trim())
    .filter((coin) => coin.length > 0);
}
